(ns app.front.ui.separator
  (:require [clojure.string :as str]))


(defn horizontal
  "A horizontal line cutting through the parent component, with optional text in the middle.

   Optional props:
   `:label-text`  (string, default nil)
   `:label-class` (string, default \"bg-gray-200\")

   Other props are passed on to the root element"
  [{:keys [label-text label-class] :as opts}]
  [:span.text-xs.w-full.flex.content-center.justify-center.text-gray-600.my-4.border-gray-500.border-t.border-solid
   (-> opts
       (dissoc :label-text)
       (dissoc :label-class))
   (when (and (string? label-text)
              (not (str/blank? label-text)))
     [:div.flex.max-w-3-4.px-4.relative.text-center
      {:style {:bottom "7px"}
       :class (or label-class "bg-gray-200")}
      label-text])])

(def horizontal-line
  "Simple line separator for sections on an application"
  :hr.my-8.border-b-0.border-t.border-solid.border-ui-dark-gray)
